import { useState } from "react";
import { Box, LinearProgress, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Records } from "../../components/records/Records";
import { RecordsHeader } from "../../components/recordsHeader/RecordsHeader";
import { useCollection } from "../../api/useCollection";
import { GapsList } from "./GapsList";
import { GAP_PRIORITY_ENTITY, gapPriorityFieldsQuery, gapPriorityOptions } from "./gapsOptions";

type GapsView = "gaps" | "priorities";

type GapsViewSeparatorProps = {
    view: GapsView;
    setView: (view: GapsView) => void;
};

const GapsViewSeparator = ({ view, setView }: GapsViewSeparatorProps) => {
    return (
        <Box>
            <ToggleButtonGroup
                value={view}
                exclusive
                onChange={(_, newValue) => {
                    if (newValue !== null) setView(newValue);
                }}
                color="secondary"
                sx={{ mb: 2, backgroundColor: "white" }}
            >
                <ToggleButton sx={{ minWidth: 220 }} value="gaps">
                    Gaps
                </ToggleButton>
                <ToggleButton sx={{ minWidth: 220 }} value="priorities">
                    Prioridades
                </ToggleButton>
            </ToggleButtonGroup>
        </Box>
    );
};

const GapPriorityRecords = ({ separator }: { separator: React.ReactNode }) => {
    const { data: collection, status: statusCollection } = useCollection(GAP_PRIORITY_ENTITY);

    if (statusCollection === "loading") return <LinearProgress color="secondary" />;
    if (statusCollection === "error") return <div>Erro ao carregar as prioridades de gaps</div>;

    return (
        <Records
            entity={GAP_PRIORITY_ENTITY}
            fieldsQuery={gapPriorityFieldsQuery}
            options={gapPriorityOptions}
            heightOfHeaders={244}
            header={
                <>
                    <RecordsHeader collection={collection} />
                    {separator}
                </>
            }
        />
    );
};

export const GapsScreen = () => {
    const [view, setView] = useState<GapsView>("priorities");
    const separator = <GapsViewSeparator view={view} setView={setView} />;

    if (view === "gaps") {
        return <GapsList separator={separator} />;
    }

    return <GapPriorityRecords separator={separator} />;
};
